import React, { useEffect } from 'react';

import Wrapper from 'components/wrapper';
import MetaTags from 'components/meta-tags';
import { useModals } from 'components/modals/use-modals';
import { ModalNames } from 'src/components/modals/modals.types';

const BrowsePage = () => {
  const { openModal, closeModal } = useModals();

  useEffect(() => {
    openModal(ModalNames.chainLocationBrowser, { hideCloseButton: true });
    return () => {
      closeModal(ModalNames.chainLocationBrowser);
    };
  }, [closeModal, openModal]);

  return (
    <Wrapper>
      <MetaTags />

      <div style={{ minHeight: '500px', height: '100%' }} />
    </Wrapper>
  );
};

export default BrowsePage;
